import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-tracking-page-menu',
  templateUrl: './tracking-page-menu.component.html',
  styleUrls: ['./tracking-page-menu.component.scss'],
})
export class TrackingPageMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() { }

}
